import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CategoryComponentDef } from '@df/catalog-ui/category/category.component.def';
import { Category, ICategoryDataV2 } from '@df/catalog/category/category';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';

@Component({
    selector: 'category',
    templateUrl: './category.component.html',
    standalone: true,
    imports: [DfImageDirective, HrefComponent, RouterModule, SizeClassDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryComponent<T extends Category<ICategoryDataV2> = Category<ICategoryDataV2>> extends CategoryComponentDef<T> {}
